import React, {useContext, useState, useEffect} from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ProductContext } from '../ProductProvider';
import { RoutesLocal } from '../routes';
import { signOut } from 'aws-amplify/auth';
import { useSnackbar } from 'notistack';
import axios from 'axios';

const config = require('../config.json');

export default function Topbar() {
   const { loggedUser, setLoggedUser, isSidebarOpen, setIsSidebarOpen, myProfileImage} = useContext(ProductContext);
   const { enqueueSnackbar } = useSnackbar();
   const navigate=useNavigate();
   const [bookResult, setBookResult] = useState([]);
   const [notificationList, setNotificaitonList] = useState([]);

   useEffect(()=>{
      if(loggedUser.isAuthenticated){
          handleBookFetch('NA','All');
      }
      return ()=>{
         setNotificaitonList([]);
      }
    },[loggedUser])


   const toggleSidebar = () => {
     setIsSidebarOpen(!isSidebarOpen);
   };

   const handleSignOut=async(event)=>{
      event.preventDefault();
      //console.log("inside sighout");
      try{
         await signOut()
         .then((res)=>{
          setLoggedUser({...loggedUser,
            name:'',
            email:'',
           // currentStatus:'',
            DOB:'',
            profile:'',
            provinceName:'',
            website:'',
            isAuthenticated:false
          }); 
          enqueueSnackbar("Logged Out Successfully",{variant : 'success'});
          navigate(RoutesLocal.Signin.path);
  
        }).catch((error)=>{
         enqueueSnackbar("Error Occured - " + error.message,{variant : 'warning'});
        })
      }catch(error){
         enqueueSnackbar("Error Occured - " + error.message,{variant : 'warning'});
      }
    }

    const handleBookFetch=async()=>{
      //event.preventDefault();
      //console.log("search book : ", searchBook);
      try{
          //const { idToken } = (await fetchAuthSession()).tokens ?? {};
          const clientID="VJCollege";
          const searchValue = loggedUser.nickname;
          const searchTopic = "UserID";
          await axios.get(`${config.bookapi.invokeURL}/vjlibrary/issue?fetchKey=${searchValue}&fetchOption=${searchTopic}&clientID=${clientID}`, {
          headers: {
           // Authorization: idToken,
           //'x-api-key':config.api.key
          }
        }).then(async(response) => {
         const tempList=notificationList;
      if(response.data.length>0){
         const tempJson={};
         tempJson.item="Library Books Assigned - ";
         tempJson.value=response.data.length;
         tempJson.link="RoutesLocal.MyBooks.path";
         //console.log("JSON : ", tempJson);
         tempList.push(tempJson);
         //console.log("temp list :", tempList);
         setNotificaitonList(tempList);
         }
          setBookResult(response.data);
          //setFilterResult(response.data);
      }).catch((error)=>{
        console.log("error:", error);
    })
      }catch(error){
          console.log("error:", error);
      }
  }
  
 
  return (
   <div>
      <div className={!isSidebarOpen?"topbar":"topbar_max"}>
         <nav className="navbar-expand-lg navbar-light">
            <div className="full d-flex justify-content-between">
               <button type="button" id="sidebarCollapse" className='sidebar_toggle' onClick={toggleSidebar}><i className="fa fa-bars"></i></button>
               <div className="logo_section ">
                  <a href="#"><span><div className='pt-1'  style={{color:"white"}}>Faculty Portal - vidyajyoti College</div></span></a>
                 
               </div>
               
               <div className="right_topbar">
             
                  <div className="icon_info">
                     <ul className="notificaiton_balloon">
                        <li ><a href="#" data-bs-toggle="dropdown"><i className="fa fa-bell-o"></i><span className="badge">{notificationList.length}</span></a>
                        <div className="dropdown-menu">
                              {notificationList.map((item,index)=><a key={index} className="dropdown-item" href="#"><Link to={item.link}> <i className="fa fa-user p-2" aria-hidden="true"></i><span>{item.item} {item.value}</span></Link></a>)}
                              {/*<a className="dropdown-item" href="#"><Link to={RoutesLocal.ResetPassword.path}> <i className="fa fa-unlock p-2" aria-hidden="true"></i><span>Change Password</span></Link></a>
                              <a className="dropdown-item" href="help.html">Help</a>
                              <a className="dropdown-item" href="#" onClick={event=>handleSignOut(event)}><Link to="#"><i className="fa fa-sign-out p-2"></i><span>Log Out</span> </Link></a>*/}
                           </div>
                           </li>

                        {/*}<li><a href="#"><i className="fa fa-question-circle"></i></a></li>
                        <li><a href="#"><i className="fa fa-envelope-o"></i><span className="badge">3</span></a></li>*/}
                     </ul>
                     <ul className="user_profile_dd">
                        <li>
                           <a className="dropdown-toggle" data-bs-toggle="dropdown"><img className="img-responsive rounded-circle" style={{background:"white", borderRadius:"25px"}} src={myProfileImage} alt="#" /><span className="name_user">{loggedUser.name}</span></a>
                           <div className="dropdown-menu">
                              <a className="dropdown-item" href="#"><Link to={RoutesLocal.MyProfile.path}> <i className="fa fa-user p-2" aria-hidden="true"></i><span>My Profile</span></Link></a>
                              <a className="dropdown-item" href="#"><Link to={RoutesLocal.ResetPassword.path}> <i className="fa fa-unlock p-2" aria-hidden="true"></i><span>Change Password</span></Link></a>
                              {/*<a className="dropdown-item" href="help.html">Help</a>*/}
                              <a className="dropdown-item" href="#" onClick={event=>handleSignOut(event)}><Link to="#"><i className="fa fa-sign-out p-2"></i><span>Log Out</span> </Link></a>
                           </div>
                        </li>
                     </ul>
                  </div>
               </div>
            </div>
         </nav>
      </div>
   </div>
  )
}
